import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`🚀 TASK: Install the Operator`}</h2>
    <a href="https://www.ibm.com/docs/en/cloud-paks/cloud-pak-aiops/4.6.0?topic=aiops-starter-installation" target="_blank">🌏 Documentation for the Task: Online starter installation of CP4AIOPS</a>
    <p>{`Next you have to install the CP4AIOPS Operator by creating the `}<inlineCode parentName="p">{`Subscription`}</inlineCode>{` as described in the Documentation.`}</p>
    <Accordion mdxType="Accordion">
      <AccordionItem title="💡 Solution?" mdxType="AccordionItem">
        <ol>
          <li parentName="ol">
            <p parentName="li">{`Run the following command:`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-yaml"
              }}>{`cat << EOF | oc apply -f -
apiVersion: operators.coreos.com/v1alpha1
kind: Subscription
metadata:
  name: ibm-aiops-orchestrator
  namespace: ibm-aiops
spec:
  channel: v4.6
  installPlanApproval: Automatic
  name: ibm-aiops-orchestrator
  source: ibm-operator-catalog
  sourceNamespace: openshift-marketplace
EOF
`}</code></pre>
          </li>
        </ol>
      </AccordionItem>
    </Accordion>
    <InlineNotification kind="info" mdxType="InlineNotification">
      <p>{`This creates the Operator Instance via the `}<inlineCode parentName="p">{`Subscription`}</inlineCode>{` that will be looking for an `}<inlineCode parentName="p">{`Installation`}</inlineCode>{` definition and start the installation if it exists (you will create this in one of the next steps). `}</p>
    </InlineNotification>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      